import { render } from "./RespuestaTransaccion.vue?vue&type=template&id=542a973a"
import script from "./RespuestaTransaccion.vue?vue&type=script&lang=js"
export * from "./RespuestaTransaccion.vue?vue&type=script&lang=js"

import "./RespuestaTransaccion.vue?vue&type=style&index=0&id=542a973a&lang=scss"

import exportComponent from "/Volumes/Baguer/Develop/Quac/pagosquac-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__